module.exports = __webpack_public_path__ + "media/images/applicant/flow-mark-square-blue-efb41bea8699add12c213718b81a163f.svg";